<ng-container *ngIf="order">
  <div class="cx-order-details-actions row">
    <div class="cx-view-all-orders">
      <span class="col-xs-12 col-md-4 col-lg-3">
        <span class="cx-action-button-left">
          <button
            id="view-all-orders-btn"
            [routerLink]="{ cxRoute: 'orders' } | cxUrl"
            class="btn btn-block btn-secondary"
          >
            {{ 'myAccountV2OrderDetails.viewAllOrders' | cxTranslate }}
          </button>
        </span>
      </span>
    </div>
    <div class="cx-other-actions">
      <span class="col-xs-12 col-md-4 col-lg-3">
        <span *ngIf="order.cancellable" class="cx-action-button">
          <button
            id="cancel-items-btn"
            [routerLink]="
              {
                cxRoute: 'orderCancel',
                params: order,
              } | cxUrl
            "
            class="btn btn-block btn-secondary"
          >
            {{ 'myAccountV2OrderDetails.cancelItems' | cxTranslate }}
          </button>
        </span>
        <span *ngIf="order.returnable" class="cx-action-button">
          <button
            id="return-items-btn"
            [routerLink]="
              {
                cxRoute: 'orderReturn',
                params: order,
              } | cxUrl
            "
            class="btn btn-block btn-secondary"
          >
            {{ 'myAccountV2OrderDetails.returnItems' | cxTranslate }}
          </button>
        </span>
        <span class="cx-action-button">
          <button
            id="download-invoices-btn"
            class="btn btn-block btn-secondary"
            (click)="showDialog(order)"
          >
            {{ 'myAccountV2OrderDetails.downloadInvoices' | cxTranslate }}
          </button>
        </span>
      </span>
    </div>
  </div>
</ng-container>
